import { FunctionComponent as F, useState } from "react";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import FolderIcon from '@mui/icons-material/Folder';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import Stack from "@mui/material/Stack";
import { usePopupState, bindTrigger } from 'material-ui-popup-state/hooks'
import { useSelector } from 'react-redux';
import { IState } from "../../core/store/store";
import RenameFolderDialog from "./RenameFolderDialog";
import FolderListItemMenu from "./FolderListItemMenu";
import DeleteFolderDialog from "./DeleteFolderDialog";
import { Grid } from "@mui/material";
import MyProtocolsList from "./MyProtocolsList";
import TooltipIfTruncated from "./TooltipIfTruncated";
import NewFolderDialog from "./NewFolderDialog";
import MoveToFolderDialog from "./MoveToFolderDialog/MoveToFolderDialog";
import NewProtocolDialog from "./NewProtocolDialog";



interface IProps
{
  folderId: number,
  indent?: number,
  drawerOpen: boolean
}

const FolderListItem: F<IProps> = (props: IProps) =>
{
  const popupState = usePopupState({ variant: 'popover' });
  const folder = useSelector((state: IState) => state.protocol.folders
    .find(f => f.folderId === props.folderId));

  const [newProtocolDialog, setNewProtocolDialog] = useState(false);
  const [moveToFolderDialog, setMoveToFolderDialog] = useState(false);
  const [deleteDialog, setDeleteFolderDialog] = useState(false);
  const [renameProtocolDialog, setRenameProtocolDialog] = useState(false);
  const [newFolderDialog, setNewFolderDialog] = useState(false);
  const [expanded, setExpanded] = useState(false);


  if(!folder)
    return <></>;

  return (
    <>

      <Grid container direction='row' sx={{ cursor: 'pointer', pt: '5px', pb: '5px' }} >
        <Grid item xs style={{ display: "flex", justifyContent: 'flex-start' }} >
          <Stack
            direction='row'
            onClick={() => setExpanded(!expanded)}
            width={220 - 8 * (props.indent || 0) + 'px'}
            sx={{ alignItems: 'center' }}>
            {expanded ?
              <FolderOpenIcon sx={{ mr: '15px', color: '#757575' }}/> :
              <FolderIcon sx={{ mr: '15px', color: '#757575' }}/>}
            {props.drawerOpen ? <TooltipIfTruncated
              text={folder.name}
              typographyProps={{ variant: 'body2'}}/> : <></>}
          </Stack>
        </Grid>
        <Grid item style={{ display: "flex", justifyContent: 'flex-end' }} {...bindTrigger(popupState)}>
          {props.drawerOpen ? <MoreHorizIcon sx={{ color: '#757575' }}/> : <></>}
        </Grid>
      </Grid>

      <FolderListItemMenu
        folderId={props.folderId}
        openNewProtocolDialog={() => setNewProtocolDialog(true)}
        setMoveToFolderDialog={setMoveToFolderDialog}
        setNewFolderDialog={setNewFolderDialog}
        setDeleteFolderDialog={setDeleteFolderDialog}
        showRenameDialog={() => setRenameProtocolDialog(true)}
        popupState={popupState}/>

      <NewProtocolDialog
        close={() => setNewProtocolDialog(false)}
        open={newProtocolDialog}
        folderId={props.folderId}/>

      <MoveToFolderDialog
        open={moveToFolderDialog}
        close={() => setMoveToFolderDialog(false)}
        folderId={props.folderId}/>

      <NewFolderDialog
        open={newFolderDialog}
        parentFolderId={props.folderId}
        close={() => setNewFolderDialog(false)}/>

      <RenameFolderDialog
        open={renameProtocolDialog}
        folderId={props.folderId}
        close={() => setRenameProtocolDialog(false)}/>

      <DeleteFolderDialog
        open={deleteDialog}
        close={() => setDeleteFolderDialog(false)}
        folderId={props.folderId}/>

      {expanded ? <MyProtocolsList {...props} indent={(props.indent || 0) + 1}/> : <></>}

    </>);
}

export default FolderListItem;

